import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import InputNumber from "primevue/inputnumber";

/**
 * PrimeVue InputNumber accepts only the locale decimal separator.
 * This wrapper also accepts the alternate character (`.` ↔ `,`) on keydown.
 * @see https://github.com/primefaces/primevue/issues/8012
 */

export default /*#__PURE__*/_defineComponent({
  __name: 'DecimalNumberInput',
  props: {
    modelValue: { default: null },
    inputId: {},
    placeholder: {},
    disabled: { type: Boolean },
    invalid: { type: Boolean, default: false },
    min: {},
    max: {},
    minFractionDigits: { default: 0 },
    maxFractionDigits: { default: 2 },
    locale: { default: "ru-RU" },
    useGrouping: { type: Boolean, default: false },
    inputClass: { default: "w-full" }
  },
  emits: ["update:modelValue", "focus", "blur"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const decimalChar =
  new Intl.NumberFormat(props.locale)
    .formatToParts(1.1)
    .find((part) => part.type === "decimal")?.value ?? ",";

const alternateDecimalChar = decimalChar === "," ? "." : ",";

function onDecimalKeydown(event: KeyboardEvent) {
  if (event.key !== alternateDecimalChar) return;
  event.preventDefault();
  const input = event.target as HTMLInputElement | null;
  if (!input) return;
  input.dispatchEvent(
    new KeyboardEvent("keypress", {
      key: decimalChar,
      bubbles: true,
      cancelable: true,
    })
  );
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(InputNumber), {
    modelValue: _ctx.modelValue,
    inputId: _ctx.inputId,
    placeholder: _ctx.placeholder,
    disabled: _ctx.disabled,
    min: _ctx.min,
    max: _ctx.max,
    minFractionDigits: _ctx.minFractionDigits,
    maxFractionDigits: _ctx.maxFractionDigits,
    mode: "decimal",
    locale: _ctx.locale,
    useGrouping: _ctx.useGrouping,
    class: _normalizeClass([_ctx.inputClass, { 'p-invalid': _ctx.invalid }]),
    inputProps: { onKeydown: onDecimalKeydown },
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (emit('update:modelValue', $event))),
    onFocus: _cache[1] || (_cache[1] = ($event: any) => (emit('focus', $event))),
    onBlur: _cache[2] || (_cache[2] = ($event: any) => (emit('blur', $event)))
  }, null, 8, ["modelValue", "inputId", "placeholder", "disabled", "min", "max", "minFractionDigits", "maxFractionDigits", "locale", "useGrouping", "class", "inputProps"]))
}
}

})